export default "__VITE_ASSET__c0f2c0c0__"